import { useState, useContext, useEffect } from "react";
import Context from "../../../context/appContext";
import { getUrl, getDependencyValue } from "../../../utils/utils";
import { Button, Modal, Form } from "antd";
import moment from "moment";

export default function ButtonField({ info, form, key, current }) {
  const [isLoading, setIsLoading] = useState(false);
  const {
    customRequest,
    dataForm: { data, formResponses, hiddenFields, disabledFields },
    setDataForm,
  } = useContext(Context);

  const logic = info && info.logic && info.logic[0] ? info.logic[0] : [];
  const json = logic.trigger && logic.trigger.json ? logic.trigger.json : {};

  useEffect(() => {
    json.action && json.action === "update" && onClick();
  }, []);

  const onClick = async () => {
    if (Object.keys(json).length > 0 && json.action) {
      if (json.action === "autocomplete") {
        setIsLoading(true);
        const opciones_servicio = getUrl(JSON.stringify(json), formResponses);
        const response = await customRequest(
          opciones_servicio.url,
          opciones_servicio.headers,
          opciones_servicio.method,
          opciones_servicio.body
        );
        if (response) {
          setIsLoading(false);
          if (response.nombreExcepcion) {
            configModal(
              "No hemos encontrado los datos en nuestro sistema. Por favor completa el formulario",
              "Aceptar",
              "Ops!"
            );
          } else {
            const keyLcl =
              opciones_servicio && opciones_servicio.key
                ? opciones_servicio.key
                : null;
            autoComplete(response, keyLcl);
          }
        }
      }
    }
  };

  const configModal = (message, btnOk, title) => {
    Modal.info({
      icon: "",
      title: title,
      className: "modal-confirm",
      closable: false,
      okButtonProps: {
        className: "ant-btn-solid c-2 ant-btn-size-xs margin-s",
      },
      okText: btnOk,
      content: <p>{message}</p>,
      onOk() {},
    });
  };

  const setInternalIdentifier = (dataI) => {
    const fValue = dataI && dataI.numeroInterno;
    const nField = { key: "internalIdentifierContratante", value: fValue };
    const index = formResponses.findIndex(
      (x) => x.key === "internalIdentifierContratante"
    );
    index != -1
      ? (formResponses[index].value = fValue)
      : formResponses.push(nField);
  };

  const autoComplete = (response, keyBtn) => {
    setInternalIdentifier(response);
    const keys = Object.keys(response);
    if (info.key === "validarRfc") {
      form.resetFields(["ciudadAsegurado", "municipioAsegurado"]);
    } else if (info.key === "validarRfcContratante") {
      form.resetFields(["ciudadContratante", "municipioContratante"]);
    }
    keys &&
      keys.length > 0 &&
      keys.forEach((val) => {
        const keyLcl = keyBtn
          ? `${val === "provinciaDomicilio" ? "estado" : val}${keyBtn}`
          : val === "colonia"
          ? `${val}Asegurado`
          : val === "provinciaDomicilio"
          ? "estadoAsegurado"
          : val;
        const item = current.newItems.find((x) => x && x.key === keyLcl);
        form.setFieldsValue({
          [keyLcl]:
            val === "pais" ||
            val === "sexo" ||
            val === "colonia" ||
            val === "provinciaDomicilio"
              ? response[val].split("-")[1].replace(" ", "")
              : val === "fechaNacimiento"
              ? moment(response[val]).format("DD/MM/YYYY")
              : response[val],
        });
        if (item) {
          const value =
            val === "pais" ||
            val === "sexo" ||
            val === "colonia" ||
            val === "provinciaDomicilio"
              ? response[val].split("-")[0].replace(" ", "")
              : response[val];
          const index = formResponses.findIndex((x) => x.key === keyLcl);
          const newVal = response[val].split("-");
          const options =
            newVal && newVal.length > 1
              ? [
                  {
                    clave: newVal[0].replace(" ", ""),
                    descripcion: newVal[1].replace(" ", ""),
                  },
                ]
              : [];

          if (index != -1) {
            formResponses[index].value = value;
            if (keyLcl && keyLcl === "primerNombre") {
              const indexName = formResponses.findIndex(
                (x) => x.key === "nombre"
              );
              if (indexName !== -1) {
                const secondName = response["segundoNombre"];
                const nameComplete = secondName
                  ? `${value} ${secondName}`
                  : value;
                formResponses[indexName].value = nameComplete;
                formResponses[index].value = nameComplete;
                form.setFieldsValue({ [key]: nameComplete });
              }
            }

            if (item.type === "select") {
              formResponses[index].valuesResponse = options;
            }
          } else {
            item.value = value;
            if (item.type === "select") {
              item.valuesResponse = options;
            }
            formResponses.push(item);
          }

          const dependencyValue = getDependencyValue(
            current,
            keyLcl,
            value,
            []
          );
          if (dependencyValue && dependencyValue.length > 0) {
            dependencyValue.forEach((x) => {
              const keyItem = Object.keys(x)[0];
              form.setFieldsValue({ [keyItem]: "" });
              hiddenFields[keyItem] = x[keyItem];
            });
            setDataForm({
              data,
              formResponses,
              hiddenFields: hiddenFields,
              disabledFields,
            });
          }
        }
      });
  };

  return (
    <>
      <Form.Item
        label={info.description ? info.description : null}
        name={info.key}
        key={key}
        hidden={hiddenFields[info.key]}
      >
        <Button
          className={
            info.action == "event"
              ? "ant-btn-solid c-transparent fake-button"
              : "ant-btn-outline custom-size c-2 ant-btn-size-xs"
          }
          onClick={onClick}
          loading={isLoading}
          disabled={disabledFields[info.key]}
        >
          {info.label}
        </Button>
      </Form.Item>
    </>
  );
}
